import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { NeurologicalQuestionnaireItem } from './questionnaire'

export const NEUROLOGICAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_HEADACHES]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_HEADACHE_TYPE]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SEIZURES]: QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SEIZURE_DATE]:
    QuestionnaireAnswerType.DATE,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SEIZURE_TYPE]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SEIZURE_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_NEURO_STATUS]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_ALTERED_AFFECT]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_ALTERED_AFFECT_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_PHQ2_SCREENING]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_PHQ2_NOTES]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_INTEREST]: QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_DEPRESSED]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_CAREGIVER_DIFFICULTY]:
    QuestionnaireAnswerType.STRING,
  [NeurologicalQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
